export const DEFAULT_ENTITIES_GROUPER = 'Todos'
